import { request } from "./requests";
import { errorMessage } from "../utils";
const { BadRequestError } = require('@shangyang/error');

// 确定当前的支付方式
export async function getPaymentWay(shortcode) {
    return await request({
        url: `/pay/way/${shortcode}`,
        method: 'get',
        retriable: false
    })
}

/**
 * 创建订单，根据 way 进行支付。way 是用户看到的支付方式，期望与后端相同。但必须对 way 进行验签，避免 hack
 * @param shortcode
 * @param way
 * @return {Promise<AxiosResponse<*>>}
 */
export async function createOrder(shortcode, way){
    try {
        return await request({
            url: `/pay/create/order`,
            data: { shortcode: shortcode, way: way },
            method: 'post',
            retriable: false // 避免重复发起支付
        });
    } catch(error) {
        if (error instanceof BadRequestError){  // TODO 遇到这个错误需要关闭前端支付窗口
            errorMessage('请求有误，请重试');
        }
        console.error(error);
        throw error;
    }
}

export async function inquireOrder(tradeId){
    try {
        return await request({
            url: `/pay/inquery/${tradeId}`,
            method: 'get',
            retriable: false
        });
    } catch(error) {
        console.error(error);
    }
}

/**
 * 注意，usercode 参数已经被移除，该参数由后台通过 JWTToken 进行解析
 * @param feedback
 * @param usercode
 * @param price
 * @param client - 目前仅需要区分 iphone 和 ipad 即可。
 * @return {Promise<void>}
 */
export async function confirmIapPayment(feedback, shortcode, price, client){
    try {
        console.log(`try to confirm iap payment with params, shortcode: ${shortcode},
            price: ${price}, client: ${client} and iap feedback logged before`);
        return await request({
            url: `/pay/confirm/iap`,
            data: {
                feedback: feedback,
                shortcode: shortcode,
                price: price,
                client: client
            },
            method: 'post',
            retriable: true // 后台实现了幂等的，这里 retry 没有问题
        });
    } catch(error) {
        console.error(error);
        throw error;
    }
}



// WEBPACK FOOTER //
// ./src/data/payment.js